//Imports node_modules
import React, { useContext, useState, useCallback } from 'react'
import Modal from 'react-modal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';
import Geolocation from '@react-native-community/geolocation';
import axios from 'axios';

//Imports Css
import './GroupProductionPage.css'

//Import Components
import TopBar from '../../../components/Global/topBar/TopBar';

//Import Images
import stopbtnicon from '../../../imgs/stop.svg'
import vanImg from './icons/DeliveryVan2.svg'
import vanIcon from './icons/DeliveryVan.svg'
import finish from './icons/finish.svg'
import group from './icons/group.svg'

import projectadd from './icons/projectadd.svg'
import projectedit from './icons/projectedit.svg'
import projectremove from './icons/projectremove.svg'

import refreshIcon from './icons/refresh.svg'
import nelugoIcon from './icons/nelugo.svg'

//Import Data
import { globalVariables } from '../../../data/GlobalVariables'
import { globalModals } from '../../../data/GlobalModals'
import { axiosCalls } from '../../../data/AxiosCalls';

import {
    Card,
    CardBody,
} from "reactstrap"

import { useEffect } from 'react';
import OptionGroupBtn from '../../../components/layout/optionGroupBtn/OptionGroupBtn';
import ListItemGroupDelivery from '../../../components/layout/listItemGroupDelivery/ListItemGroupDelivery';
import ModalPickupFuncionario from '../../../components/Global/modals/modalPickupFuncionario/modalPickupFuncionario';

//Pagina onde o cliente selciona a entidade
const GroupProductionPage = (props) => {

    //Para não dar erro no modal
    Modal.setAppElement('body');

    //---------------------------------------------------------------------------------------------------------------------------------------------------
    //*                                                        Variaveis de contexto                                                                    *
    //---------------------------------------------------------------------------------------------------------------------------------------------------

    const {
        zone,
        groupPe,
        stepsList,
        apiBaseUrl,
        ResetGroupPe,
        defineGroupProduction,
        operationGroupProduction,
        setOperationGroupProduction,
        selectedObraForGroupProduction,
    } = useContext(globalVariables)

    const {
        ShowMessageModal,
        ShowLoadingModal,
        DismisMessageModal,
        DismisLoadingModal,
    } = useContext(globalModals);

    const {
        AxiosPost
    } = useContext(axiosCalls)


    //---------------------------------------------------------------------------------------------------------------------------------------------------
    //*                                                        Variaveis locais                                                                         *
    //---------------------------------------------------------------------------------------------------------------------------------------------------

    const navigate = useNavigate();
    const cookies = new Cookies();
    const queryParams = new URLSearchParams(window.location.search);

    const [isShowingFunc, setShowingFunc] = useState(false)

    const [refresh, setRefresh] = useState(new Date());
    const [modalFuncInProductionStatus, setModalFuncInProductionStatus] = useState(false)
    const [isLoading, setIsLoading] = useState(false)


    //--------Operation Buttons
    //---Special operation Buttons -Este butões execctam funções unicas a eles

    const buttonStartOperation = {
        text: 'Começar deslocamento',
        color: '#4A83B1',
        icon: vanIcon,
        size: 24,
        operacao: function operacao() {
            if (!isLoading) {
                startJorney();
            }
        }
    }

    const buttonStartTravel = {
        text: 'Iniciar deslocamento entre obras',
        color: '#4A83B1',
        icon: vanIcon,
        size: 24,
        operacao: function operacao() {
            if (!isLoading) {
                startJorneyToAnotherProject()
            }
        }
    }

    const buttonStartTravelToHome = {
        text: 'Iniciar deslocamento para Nelugo',
        color: '#4A83B1',
        icon: nelugoIcon,
        size: 20,
        operacao: function operacao() {
            if (!isLoading) {
                startTravelToHome()
            }
        }
    }

    const buttonCancelJorney = {
        text: 'Cancelar deslocação',
        color: '#E76965',
        icon: stopbtnicon,
        size: 15,
        operacao: function operacao() {
            if (!isLoading) {
                cancelJorney();
            }
        }
    }

    //before
    const buttonFinishJorney = {
        text: 'Começar nova viagem',
        color: '#4A83B1',
        icon: refreshIcon,
        size: 21,
        operacao: function operacao() {
            if (!isLoading) {
                resetVariavels();
            }
        }
    }

    const buttonShowModalFunc = {
        text: 'Levantar funcionários',
        color: '#009688',
        icon: group,
        size: 21,
        operacao: function operacao() {
            if (!isLoading) {
                setModalFuncInProductionStatus(true)
            }
        }
    }

    //---End Special operation Buttons
    //---Common operation Buttons - Este Buttões partilha dois tipos os de query de adicionar e os de query de update
    const buttonAddProject = {
        text: 'Registar incio de obra',
        color: '#78A753',
        icon: projectadd,
        size: 21,
        operacao: function operacao() {
            if (!isLoading) {
                var date = new Date();
                date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));
                cookies.set('projectConfigStatus', 1, { path: '/', expires: date });
                navigate('/productionWorkListPage?groupProduction=true')
            }
        }
    }

    const buttonEditProject = {
        text: 'Editar obra actual',
        color: '#F8A351',
        icon: projectedit,
        size: 21,
        operacao: function operacao() {
            if (!isLoading) {
                var date = new Date();
                date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));
                cookies.set('projectConfigStatus', 2, { path: '/', expires: date });
                navigate('/productionWorkListPage?groupEditProduction=true')
            }
        }
    }

    const buttonRemoveProject = {
        text: 'Remover obra actual',
        color: '#E76965',
        icon: projectremove,
        size: 21,
        operacao: function operacao() {
            if (!isLoading) {
                cancelProject()
            }
        }
    }

    const buttonFinishStartTravel = {
        text: 'Finalizar deslocamento Inicial',
        color: '#4A83B1',
        icon: finish,
        size: 21,
        operacao: function operacao() {
            if (!isLoading) {
                closeTravel()
            }
        }
    }

    const buttonFinishTravel = {
        text: 'Finalizar deslocamento',
        color: '#E76965',
        icon: finish,
        size: 21,
        operacao: function operacao() {
            if (!isLoading) {
                closeTravel()
            }
        }
    }

    const buttonConcludeJorney = {
        text: 'Finalizar viagem',
        color: '#E76965',
        icon: finish,
        size: 21,
        operacao: function operacao() {
            if (!isLoading) {
                concludeJorney();
            }
        }
    }


    //---------------------------------------------------------------------------------------------------------------------------------------------------
    //*                                                        Variaveis UseCallback                                                                    *
    //---------------------------------------------------------------------------------------------------------------------------------------------------

    const currentOperacao = useCallback(function (operacao) {
        operacao.operacao();
    }, [])

    const closeWorkForSelEmployee = useCallback(function (userList) {
        getUsersFromWork(userList)
    }, [])

    //---------------------------------------------------------------------------------------------------------------------------------------------------
    //*                                                        Funçoes UseEffect                                                                        *
    //---------------------------------------------------------------------------------------------------------------------------------------------------

    useEffect(() => {

        const receivedOperation = localStorage.getItem("queryParams");

        if (receivedOperation !== null && receivedOperation !== undefined) {
            switch (receivedOperation) {
                case 'addProject':
                    addReceivedProject();
                    break;
                case 'editProject':
                    editReceivedProject();
                    break;
                case 'travelobra':
                    startTravelToProject();
                    break;
                case 'startProduction':
                    startJorneyAfterSetGroup();
                    break;
                default:
                    break
            }
        }
        // eslint-disable-next-line
    }, [])

    //Este Useeffect serve para ler a base de dados e dar refresh á stepList
    //Isto é feito para qunado o utlizador sa da aplicação da tablet e ele assim perde os dados
    useEffect(() => {

        var localGrupoStamp = localStorage.getItem('grupostamp')
        var localJorneystamp = localStorage.getItem('jorneystamp')

        var receivedOperation = localStorage.getItem("queryParams");
        if (receivedOperation === null || receivedOperation === undefined) {
            localStorage.setItem("queryParams", "noOP");
            receivedOperation = 'noOP'

        }
        if (receivedOperation === 'noOP') {
            if (localGrupoStamp !== undefined && localGrupoStamp !== null && localJorneystamp !== null && localJorneystamp !== undefined && localJorneystamp !== '') {
                setIsLoading(true)
                ShowLoadingModal();

                AxiosPost(('Jorney/getJorneyList?grupoStamp=' + localGrupoStamp + '&jorneyStamp=' + localJorneystamp), 'message', 'Erro a ler os passos do deslocamento',
                    function comutereponse(response) {

                        //Variaveis a defenir os passos
                        var stepsLocal = [];
                        var lastStepUseEffect = {};
                        var showPickupEmployee = false;

                        Object.keys(response.data).forEach(function (steps, stepIndex) {
                            switch (response.data[stepIndex].cttType) {
                                case 0: response.data[stepIndex].onclick = function onClick() { console.log('') }
                                    break;
                                case 1: response.data[stepIndex].onclick = function onClick() { console.log('') }
                                    break;
                                case 2: response.data[stepIndex].onclick = function onClick() { console.log('Delete this line') }
                                    break;
                                default: response.data[stepIndex].onclick = function onClick() { console.log('') }
                                    break;
                            }

                            stepsLocal.push(response.data[stepIndex]);

                            if (response.data[stepIndex].cttType === 2 && response.data[stepIndex].horaF === "") {
                                showPickupEmployee = true
                            }

                            //Ignora caso seja 5 pois representa Levantamento de funcionarios
                            if (response.data[stepIndex].cttType !== 5) {
                                lastStepUseEffect = response.data[stepIndex];
                            }
                        });

                        var operacoesLocal = []

                        //Define as operações dependendo da ultinha linha de operação
                        switch (lastStepUseEffect.cttType) {
                            case 1:
                                if (lastStepUseEffect.horaF !== '') {
                                    operacoesLocal.push(buttonAddProject);
                                    operacoesLocal.push(buttonStartTravelToHome);
                                } else {
                                    operacoesLocal.push(buttonFinishStartTravel);
                                    operacoesLocal.push(buttonCancelJorney);
                                }
                                break;
                            case 2:
                                if (lastStepUseEffect.horaF !== '') {
                                    operacoesLocal.push(buttonStartTravel);
                                    operacoesLocal.push(buttonStartTravelToHome);
                                } else {
                                    operacoesLocal.push(buttonStartTravel);
                                    operacoesLocal.push(buttonStartTravelToHome);
                                    operacoesLocal.push(buttonEditProject);
                                    operacoesLocal.push(buttonRemoveProject);
                                    showPickupEmployee = false;
                                }
                                break;
                            case 3:
                                if (lastStepUseEffect.horaF !== '') {
                                    operacoesLocal.push(buttonStartTravel);
                                    operacoesLocal.push(buttonAddProject);
                                    operacoesLocal.push(buttonStartTravelToHome);

                                } else {
                                    operacoesLocal.push(buttonFinishTravel);
                                }
                                break;
                            case 4:
                                if (lastStepUseEffect.horaF !== '') {
                                    operacoesLocal.push(buttonFinishJorney);
                                } else {
                                    if (!showPickupEmployee) {
                                        operacoesLocal.push(buttonConcludeJorney);
                                    }
                                }

                                break;
                            default:
                                break;
                        }

                        //Adiciona um opção para ler os utilizadores a importar
                        if (showPickupEmployee) {
                            operacoesLocal.push(buttonShowModalFunc)
                        }

                        localStorage.setItem('lastSetInList', lastStepUseEffect.cct.trim());

                        defineGroupProduction(stepsLocal, operacoesLocal)

                        DismisLoadingModal();
                        setIsLoading(false)
                    });
            } else {
                var initalOptions = [];
                initalOptions.push(buttonStartOperation);
                setOperationGroupProduction(initalOptions);
                DismisLoadingModal();
            }
        }

        // eslint-disable-next-line
    }, [refresh])

    //---------------------------------------------------------------------------------------------------------------------------------------------------
    //*                                                        Funçoes Locais                                                                           *
    //---------------------------------------------------------------------------------------------------------------------------------------------------

    //---------------------------Operações para ler o resize da página----------------------------
    const [isSmallScreen, setIsSmallScreen] = useState(false);
    const [divModalSizeHeight, setDivModalSizeHeight] = useState(0);
    const [dimensions, setDimensions] = React.useState({ width: window.innerWidth, height: window.innerHeight, });
    const handleResize = () => { setDimensions({ width: window.innerWidth, height: window.innerHeight, }); }
    React.useEffect(() => { window.addEventListener("resize", handleResize, false); }, []);
    React.useEffect(() => { if (dimensions.width < 992) { setIsSmallScreen(true); } else { setIsSmallScreen(false) } setDivModalSizeHeight(dimensions.height); }, [dimensions]);
    //---------------------------Fim Operações para ler o resize da página------------------------

    function nextBtnClick() { }
    function backbtnClick() { navigate('/userPage') }

    function startJorneyToAnotherProject() {
        //Mensagem a confimar antes de apagar
        ShowMessageModal(
            {
                modaltype: 'info',
                modalTitle: 'Inicializar deslocamento',
                modalMessage: 'Antes de inicializar o deslocamento pretende modificar a equipa?',
                specialButons: 'true',
                nextClick: function nextClick() {
                    setTimeout(function () { startTravelToProjectNoVerification() }, 50);	// Não remover este, para não dar flick
                },
                nextBtnTxt: 'Manter membros',
                crossClick: 'dismiss',
                backClick: function backClick() {
                    DismisMessageModal();
                    var date = new Date();
                    date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));
                    cookies.set('projectConfigStatus', 4, { path: '/', expires: date });
                    localStorage.setItem("queryParams", "editarGroup");
                    setTimeout(function () { navigate('/userPage') }, 50);	// Não remover este, para não dar flick
                },
                backBtnTxt: 'Modificar membros',
            })
    }

    function closeTravel() {
        var lastStepInList = localStorage.getItem('lastSetInList')

        //Mensagem a confimar antes de apagar
        ShowMessageModal(
            {
                modaltype: 'info',
                modalTitle: 'Concluir projeto',
                modalMessage: ('Deseja concluir o deslocamento?'),
                nextClick: function nextClick() {
                    setTimeout(function () { confirmedCloseLastStep(lastStepInList) }, 50);	// Não remover este, para não dar flick
                },
                nextBtnTxt: 'Confirmar',
                crossClick: 'dismiss',
                backClick: 'dismiss',
            }
        )
    }

    function concludeJorney() {
        var lastStepInList = localStorage.getItem('lastSetInList')
        ShowMessageModal(
            {
                modaltype: 'info',
                modalTitle: 'Concluir deslocamento',
                modalMessage: 'Deseja mesmo o concluir o deslocamento final?',
                nextClick: function nextClick() {
                    DismisMessageModal();
                    setTimeout(function () { confirmedCloseLastStep(lastStepInList) }, 50);	// Não remover este, para não dar flick
                },
                nextBtnTxt: 'Confirmar',
                crossClick: 'dismiss',
                backClick: 'dismiss',
            }
        )
    }

    function cancelProject() {
        ShowMessageModal(
            {
                modaltype: 'info',
                modalTitle: 'Cancelar obra',
                modalMessage: 'Deseja mesmo cancelar a última obra inserida?',
                nextClick: function nextClick() {
                    DismisMessageModal();
                    setTimeout(function () { confirmedCancelProject() }, 50);	// Não remover este, para não dar flick
                },
                nextBtnTxt: 'Confirmar',
                crossClick: 'dismiss',
                backClick: 'dismiss',
            }
        )
    }

    function cancelJorney() {
        ShowMessageModal(
            {
                modaltype: 'info',
                modalTitle: 'Cancelar deslocamento',
                modalMessage: 'Deseja mesmo cancelar o deslocamento de hoje?',
                nextClick: function nextClick() {
                    DismisMessageModal();
                    setTimeout(function () { confirmedCancelTravel() }, 50);	// Não remover este, para não dar flick
                },
                nextBtnTxt: 'Confirmar',
                crossClick: 'dismiss',
                backClick: 'dismiss',
            }
        )
    }

    //---- End Confirm Operation

    //---- Operations
    function startJorney() {
        if (localStorage.getItem('storedGroupMembers')) {
            startJorneyAfterhhh()
        } else {
            var date = new Date();
            date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));
            cookies.set('projectConfigStatus', 3, { path: '/', expires: date });
            navigate('/userPage?createGroup=true')
        }
    }

    function startJorneyAfterhhh() {

        ShowLoadingModal();

        makeCall(false, '', 'Saida Nelugo', 1, 'Production/startNewProduction', function resultFunction(response) {

            var date = new Date();
            date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));

            localStorage.setItem('grupostamp', response.data.stampGrupo);
            localStorage.setItem('jorneystamp', response.data.stampJorney);
            localStorage.setItem('jorneyStatus', 1);
            cookies.set('projectConfigStatus', 0, { path: '/', expires: date });

            setRefresh(new Date());
        });
    }

    function startJorneyAfterSetGroup() {
        if (cookies.get('projectConfigStatus') === '3') {
            ShowLoadingModal();
            makeCall(false, '', 'Saida Nelugo', 1, 'Production/startNewProduction', function resultFunction(response) {

                var date = new Date();
                date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));

                localStorage.setItem('grupostamp', response.data.stampGrupo);
                localStorage.setItem('jorneystamp', response.data.stampJorney);
                localStorage.setItem('jorneyStatus', 1);
                cookies.set('projectConfigStatus', 0, { path: '/', expires: date });
                localStorage.setItem("queryParams", "noOP");
                setRefresh(new Date());
            });
        }
    }

    function startTravelToProject() {
        if (cookies.get('projectConfigStatus') === '4') {
            ShowLoadingModal();
            var lastStepInList = localStorage.getItem('lastSetInList')

            makeCall(false, '', lastStepInList, 2, 'Jorney/closeStepInList', function resultFunction(response) {
                makeCall(false, '', 'Deslocamento entre obras', 3, 'Jorney/addStepToList', function resultFunction(response) {
                    var date = new Date();
                    date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));
                    cookies.set('projectConfigStatus', 0, { path: '/', expires: date });
                    localStorage.setItem("queryParams", "noOP");
                    setRefresh(new Date());
                });
            });
        }
    }

    function startTravelToProjectNoVerification() {

        ShowLoadingModal();

        var lastStepInList = localStorage.getItem('lastSetInList')
        makeCall(false, '', lastStepInList, 2, 'Jorney/closeStepInList', function resultFunction(response) {
            makeCall(false, '', 'Deslocamento entre obras', 3, 'Jorney/addStepToList', function resultFunction(response) {
                var date = new Date();
                date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));
                cookies.set('projectConfigStatus', 0, { path: '/', expires: date });

                setRefresh(new Date());
            });
        });
    }

    function startTravelToHome() {
        ShowLoadingModal();

        var lastStepInList = localStorage.getItem('lastSetInList')
        makeCall(false, '', lastStepInList, 2, 'Jorney/closeStepInList', function resultFunction(response) {
            makeCall(false, '', 'Deslocamento para a Nelugo', 4, 'Jorney/addStepToList', function resultFunction(response) {
                setRefresh(new Date());
            });
        });
    }

    function addReceivedProject() {
        if (cookies.get('projectConfigStatus') === '1') {
            ShowLoadingModal()
            makeCall(false, selectedObraForGroupProduction.custamp, selectedObraForGroupProduction.cct, 2, 'Jorney/addStepToList', function resultFunction(response) {
                var date = new Date();
                date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));
                cookies.set('projectConfigStatus', 0, { path: '/', expires: date });
                localStorage.setItem("queryParams", "noOP");
                setRefresh(new Date());
            });
        }
    }

    function editReceivedProject() {
        if (cookies.get('projectConfigStatus') === '2') {
            ShowLoadingModal()

            makeCall(false, selectedObraForGroupProduction.custamp, selectedObraForGroupProduction.cct, 2, 'Jorney/alteraDocumento', function resultFunction(response) {
                var date = new Date();
                date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));
                cookies.set('projectConfigStatus', 0, { path: '/', expires: date });
                localStorage.setItem("queryParams", "noOP");
                setRefresh(new Date());
            });
        }
    }

    function confirmedCancelProject() {
        ShowLoadingModal();
        makeCall(false, '', '', 2, 'Jorney/removeLastStep', function resultFunction(response) {
            setRefresh(new Date());
        });
    }

    function confirmedCancelTravel() {
        ShowLoadingModal();
        makeCall(false, '', '', 2, 'Jorney/removeLastStep', function resultFunction(response) {
            resetVariavels();
        });
    }

    function confirmedCloseLastStep(lastStepInList) {
        ShowLoadingModal();
        makeCall(false, '', lastStepInList, 2, 'Jorney/closeStepInList', function resultFunction(response) {
            setRefresh(new Date());
        });
    }

    function getUsersFromWork(userList) {
        setModalFuncInProductionStatus(false)
        ShowLoadingModal()
        //Fechas os funcionarios que ainda estãoem produção
        makeCall(userList, '', 'Levantamento de funcionário', 5, 'Jorney/getEmployeeFromWork', function resultFunction(response) {


            //Adiciona a userList ao menbros de grupo
            var groupList = JSON.parse(localStorage.getItem('storedGroupMembers'));

            //Altera objecto de utilizadores 
            Object.keys(userList).forEach(function (user, index) {
                var convertedUser = {}
                convertedUser.npe = userList[index].npe;
                convertedUser.nmpe = userList[index].nmpe.trim();
                convertedUser.pin = "2004"
                groupList.push(convertedUser)
            });

            var date = new Date();
            date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));

            localStorage.setItem('storedGroupMembers', JSON.stringify(groupList));

            setRefresh(new Date());

            toast.success('Levantamento gravado!', {
                position: "top-right",
                autoClose: 2400,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        });
    }

    function makeCall(filteredGroupMembers, cuStamp, cct, cctType, apiCall, resultFunction) {
        Geolocation.getCurrentPosition(info => {

            let finalCallObjject = {};

            finalCallObjject.groupStamp = localStorage.getItem('grupostamp');
            finalCallObjject.jorneyStamp = localStorage.getItem('jorneystamp');
            finalCallObjject.cuStamp = cuStamp;
            finalCallObjject.cttType = cctType;
            finalCallObjject.nctt = zone.nctt;
            finalCallObjject.cct = cct;
            finalCallObjject.location = info.coords.latitude + " " + info.coords.longitude;

            //Tenho de mandar o numero de todos os pe caso seja grupo
            finalCallObjject.singlePeNpe = 0;
            finalCallObjject.groupPe = groupPe;

            if (filteredGroupMembers === false) {
                var groupMenbers = JSON.parse(localStorage.getItem('storedGroupMembers'))
                finalCallObjject.groupPeMembers = JSON.stringify(groupMenbers);
            } else {
                finalCallObjject.groupPeMembers = JSON.stringify(filteredGroupMembers)
            }

            //Query para ler os funçionarios/grupos que o dispositivo tem acesso
            axios.post(apiBaseUrl + apiCall, finalCallObjject, { timeout: 50000 }).then((responseStart) => {
                const isDataAvailable = responseStart.data !== undefined && responseStart.data !== "";
                if (isDataAvailable) {
                    const myJSON = JSON.stringify(responseStart.data);

                    if (myJSON.slice(0, 6) === '"Erro:') {
                        ShowMessageModal(
                            {
                                modaltype: 'warning',
                                modalTitle: 'Atenção!',
                                modalMessage: responseStart.data.substring(5),
                                nextClick: 'dismiss',
                                nextBtnTxt: 'Cooprendi',
                                crossClick: 'dismiss',
                                backClick: 'dismiss',
                            })
                    } else {
                        resultFunction(responseStart)
                        //Isto é para quando o utilizador reiniciar o pc ele não perder as cookies do grupo
                    }
                } else {
                    DismisLoadingModal()
                    ShowMessageModal(
                        {
                            modaltype: 'info',
                            modalTitle: 'teste',
                            modalMessage: 'teste'
                        });
                }
            }, (error) => {
                DismisLoadingModal()
                if (error.code == "ECONNABORTED") {
                    ShowMessageModal(
                        {
                            modaltype: 'error',
                            modalTitle: 'Atenção!',
                            modalMessage: 'Não foi possível comunicar com o servidor, por favor verifique a conexão á internet!',
                            nextClick: 'dismiss',
                            nextBtnTxt: 'Cooprendi',
                            crossClick: 'dismiss',
                        })
                } else {
                    ShowMessageModal(
                        {
                            modaltype: 'error',
                            modalTitle: 'Atenção!',
                            modalMessage: 'Erro ao comunicar com o servidor, por favor tente novamente! Caso o problema persista entre em contacto com o administrador!',
                            nextClick: 'dismiss',
                            nextBtnTxt: 'Cooprendi',
                            crossClick: 'dismiss',
                        })
                }
            });
        }, (info => {
            DismisLoadingModal()
            ShowMessageModal(
                {
                    modaltype: 'error',
                    modalTitle: 'Erro na localização.',
                    modalMessage: 'Precisa de pertimitir acesso á sua localização.',
                    nextClick: 'dismiss',
                    nextBtnTxt: 'Compreendi',
                    crossClick: 'dismiss',
                });
        }
        ));
    }

    function resetVariavels() {
        ResetGroupPe();
        var date = new Date();
        date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));
        var emptyObject = []
        localStorage.setItem('storedGroupMembers', JSON.stringify(emptyObject));

        localStorage.removeItem('storedGroupMembers');
        localStorage.removeItem('grupostamp');
        localStorage.removeItem('jorneyStatus');
        localStorage.removeItem('jorneystamp');
        setRefresh(new Date());
    }

    //----------------------------------------------------------------- Layout and functions Layout------------------------------------------------
    function renderProductionLine() {
        //Layout da linha de produção
        return (
            <Card style={{ height: '100%', width: '100%', maxWidth: '9999px' }}>
                <CardBody style={{ height: '100%', width: '100%', display: 'flex' }}>
                    {(localStorage.getItem('jorneyStatus') !== 0 && localStorage.getItem('jorneyStatus') !== undefined && localStorage.getItem('jorneyStatus') !== null) ?
                        //Layout de historico das linha de produção
                        <div className='withProdcution'>
                            <h3>Ordem de produção</h3>

                            <div className="flexLayoutContainer" style={{ height: divModalSizeHeight - 200, width: '95%', position: 'fixed' }}>
                                <div className='flexLayoutScrollable' >
                                    <ul className="RDashList">
                                        {showTable()}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        :
                        //Prompt a pedir para começar a produção
                        <div className="noProdcutionWarning" onClick={e => startJorney()}>
                            <div className='noProdcutionCenterIcon'>
                                <img src={vanImg} alt="Carrinha" style={{ height: '99px', width: '99px' }} />
                                <p className='noProductionCenterText'>Por favor inicie<br></br> a produção</p>
                            </div>
                        </div>
                    }
                </CardBody>
            </Card>
        )
    }

    function renderOptionList() {
        return (
            <Card style={{ height: '100%', width: '100%', maxWidth: '9999px' }} >
                <div style={{ paddingTop: '1rem', paddingBottom: '0.5rem', paddingLeft: '1.7rem', paddingRight: '0.9rem' }}>
                    <div className="d-flex">
                        <div className="me-2">
                            <i className="mdi mdi-file-document-outline text-primary h1" />
                        </div>
                        <div className="flex-grow-1">
                            <div className="text-muted">
                                <h4><strong>Operações:</strong></h4>
                                {/* Barra divisoria*/}
                            </div>
                        </div>
                    </div>
                </div>

                <CardBody style={{ paddingTop: '1.0rem', paddingBottom: '0rem', paddingLeft: '0.9rem', paddingRight: '0.5rem', borderTop: '1px solid #eff2f7' }}>
                    <div>
                        {
                            localStorage.getItem("queryParams") === 'noOP' && operationGroupProduction && !isLoading ?
                                operationGroupProduction.map(
                                    (operacao, index) =>
                                        <OptionGroupBtn key={index} operacao={operacao} onClick={currentOperacao}></OptionGroupBtn>
                                )
                                :
                                false
                        }
                    </div>
                </CardBody>
            </Card>
        )
    }

    function renderGroupList() {
        return (
            <Card style={{ height: '100%', width: '100%', maxWidth: '9999px' }} >
                <div style={{ paddingTop: '1rem', paddingBottom: '0.5rem', paddingLeft: '1.7rem', paddingRight: '0.9rem' }}>
                    <div className="d-flex" >
                        <div className="me-2">
                            <i className="mdi mdi-file-document-outline text-primary h1" />
                        </div>
                        <div className="flex-grow-1">
                            <div className="text-muted">
                                <h4>
                                    <strong>
                                        Membros na carrinha:
                                    </strong>
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
                <CardBody style={{ paddingTop: '1.0rem', paddingBottom: '0rem', paddingLeft: '0.9rem', paddingRight: '0.5rem', borderTop: '1px solid #eff2f7', height: '100%' }}>
                    <div style={{ paddingTop: '4px' }}>
                        {localStorage.getItem('storedGroupMembers') ?
                            <div className="table-responsive" style={{ width: '96%' }}>
                                <table className="table-nowrap table">
                                    <thead>
                                        <tr>
                                            <th style={{ width: '70px' }}>Nº.</th>
                                            <th>Nome</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {JSON.parse(localStorage.getItem('storedGroupMembers')).map((member, index) =>
                                            <tr key={member.npe}>
                                                <td>{member.npe}</td>
                                                <td>{member.nmpe}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div> :
                            <div>
                                <div className="noProdcutionWarning" onClick={e => startJorney()} >
                                    <div className='noProdcutionCenterIcon' >
                                        <p className='noProductionCenterText'>Por favor inicie<br></br> a produção</p>
                                    </div>
                                </div>
                            </div>}
                    </div>
                </CardBody>
            </Card>
        )
    }

    function showTable() {
        //Mapea todas a passos feitos pela equipa até agora..
        return (stepsList.map((step, index) => {
            return (
                <ListItemGroupDelivery
                    key={index}
                    chave={index}
                    step={step}>
                </ListItemGroupDelivery>)
        }))
    }

    function closeModal() {
        setModalFuncInProductionStatus(false);
    }

    return (
        <div className="GroupProductionPage">
            <div className='topbar'>
                <TopBar texto='Logística de deslocamento' type='blue' backText='Voltar' nextBtnClick={nextBtnClick} backbtnClick={backbtnClick} layout='1'></TopBar>
            </div>
            <div className="flexLayoutContainer" style={{ height: divModalSizeHeight, width: '100%', padding: '16px', position: 'fixed' }}>
                <div className='flexLayoutScrollable' style={{ marginTop: '60px', paddingRight: '5px' }}>
                    {isSmallScreen ?
                        <div className='flexLayoutScrollable' style={{ paddingRight: '5px' }}>
                            <div style={{ height: '304px', marginBottom: '20px', display: 'flex', flexDirection: 'row' }}>
                                <div style={{ flex: '1', marginRight: '5px' }}>
                                    {renderOptionList()}
                                </div>
                                <div style={{ flex: '1', marginLeft: '5px' }}>
                                    {renderGroupList()}
                                </div>
                            </div>
                            <div style={{ height: '600px', paddingBottom: '0.7rem', paddingRight: '0.5rem' }}>
                                {renderProductionLine()}
                            </div>
                        </div>
                        :
                        <div style={{ height: '98%', display: 'flex' }}>
                            <div className='flex-itemNav' >
                                <div style={{ height: '100%', paddingLeft: '0.5rem', paddingRight: '1.5rem' }}>
                                    {renderProductionLine()}
                                </div>
                            </div>
                            <div className='infoListParentLayot'>
                                <div style={{ flex: '1', marginBottom: '7px' }}>
                                    {renderOptionList()}
                                </div>
                                <div style={{ flex: '1', marginTop: '7px' }}>
                                    {renderGroupList()}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>

            <ModalPickupFuncionario isOpen={modalFuncInProductionStatus} closeModal={closeModal} nextFunction={closeWorkForSelEmployee}></ModalPickupFuncionario>

            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />

            {/* Same as */}
            <ToastContainer />
        </div>
    )

    //----------------------------------------------------------------------- End Layout and functions Layout------------------------------------------
}
export default GroupProductionPage